namespace SorAraBul.Administration {
    export class UserCreditPaymentOrderColumns {
        static columnsKey = 'Administration.UserCreditPaymentOrder';
    }
}
